module.exports = __webpack_public_path__ + "static/media/Opening_Stock_Upload_Template.f3d1ba53.xlsx";